class viewCartItemsController {
    /* @ngInject */
    constructor(cartService, product, notificationService, siteLinksService) {
        this.cartService = cartService;
        this.product = product;
        this.notificationService = notificationService;
        this.siteLinksService = siteLinksService;
    }

    $onInit() {
        this.PRODUCT_MIN_QUANTITY = this.product.PRODUCT_MIN_QUANTITY;
        this.PRODUCT_MAX_QUANTITY = this.product.PRODUCT_MAX_QUANTITY;
        this.myQuotesUrl = this.siteLinksService.myQuotesUrl;
    }

    removeProduct(product) {
        var _self = this;
        var element = angular.element(document.querySelector(".one-product-wrapper[data-productcode='" + product.productCode + "']"));
        var productDesc = _self.getProductDescription(product);
        element.fadeOut("slow", function(){
            var message = 'Product \'' + productDesc + '\' has been removed.';
            var removeCartPromise = _self.cartService.removeCartItem(product);
            return removeCartPromise.then(function() {
                return _self.retrieveCart(message);
            })
        });
    };

    updateQuantity(product, quantity) {
        if(product.quantity >= this.PRODUCT_MIN_QUANTITY && product.quantity <= this.PRODUCT_MAX_QUANTITY) {
            var productDesc = this.getProductDescription(product);
            var message = 'Quantity for product \'' + productDesc + '\' has been updated.';
            var updateCartPromise = this.cartService.updateCartItemQuantity(product);
            var _self = this;
            return updateCartPromise.then(function() {
                return _self.retrieveCart(message);
            })
        }
    };

    retrieveCart(message) {
        var _self = this;
        return _self.cartService.retrieveViewCartModel().then(function (result) {
            _self.setCart(result);
            _self.notificationService.notifyWithDefaults({
                title: 'Success',
                title_escape: false,
                text: message,
                text_escape: false,
                styling: "fontawesome",
                type: "success",
                icon: true,
                buttons: {
                    sticker: false
                },
                delay: 3000
            }, 'custom_stack');
        });
    };

    setCart(cart){
        this.cart = cart;
    }

    getProductDescription(product) {
        var productDesc = '';

        if(product.brand !== null) {
            productDesc += product.brand + ' ';
        }

        if(product.style !== null) {
            productDesc += product.style + ' ';
        }

        if(product.internetDescription !== null) {
            productDesc += product.internetDescription;
        }

        return productDesc ? productDesc.trim() : product.productCode;
    }

    displayPrice(product) {

        if(product.isValid && (product.quoteId === null || product.quoteId.length === 0)) {
            return true;
        }

        if(product.isValid && product.quoteId.length > 0 && this.canViewQuotePrices) {
            return true;
        }

        return false;
    }
}

export default viewCartItemsController;



// WEBPACK FOOTER //
// ./src/app/components/view-cart/view-cart-items/view-cart-items.controller.js